/* Create By PRATAN : 2023-05-24
   Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
   Update By POOM : 13/05/2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

*/

import React, { useState ,useEffect} from 'react';
// eslint-disable-next-line
import {Class_ETC_MsgError,
        Class_ETC_MsgErrorfocusByID,
        Class_ETC_MsgSuccess,
        Class_ETC_SessionTimeOut
    } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import { Class_ETC_Logout } from "../Class/Class_Etc";

function ChangePasswordAction({Act}) {
    
    const [isLoadProgress, setIsLoadProgress] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);

    const [passwordShow, setPasswordShow] = useState(false);
    const [newShow, setNewShow] = useState(false);
    const [confirmShow, setConfirmShow] = useState(false);


    
    // eslint-disable-next-line
    const [configData, setConfigData] = useState([]);

    useEffect(() => {

        if (isFirst === true) {
            GetConfig();
            if (isLoadedConfigData === true) {
                  setIsFirst(false);
            }
        }
        // eslint-disable-next-line
      }, [isLoadedConfigData]);

    const togglePasswordShow = () => { setPasswordShow(!passwordShow); };
    const toggleNewPassword = () => { setNewShow(!newShow); };
    const toggleChangeConfirmPassword = () => { setConfirmShow(!confirmShow); };

    async function GetConfig() {
        await fetch("../ConfigData.json")
        .then((res) => res.json())
        .then((data) => {
            setConfigData(data);
            setIsLoadedConfigData(true);
        })
        .catch((err) => err);
    }

    function onclick_ChangePassword(){
        setIsLoadProgress(true);

        var istxtError = "";
        let isError = "";
        var txt_Modal_New_Password = document.getElementById("txt_Modal_New_Password").value.trim();
        var txt_Modal_Confirm_New_Password = document.getElementById("txt_Modal_Confirm_New_Password").value.trim();

        if (txt_Modal_New_Password === "") 
        {
            istxtError = "txt_Modal_New_Password";
        } 
        else if (txt_Modal_Confirm_New_Password === "") 
        {
            istxtError = "txt_Modal_Confirm_New_Password";
        }

        if (istxtError !== "") 
        {
        isError = "Empty";
        }

        if (txt_Modal_New_Password !== txt_Modal_Confirm_New_Password) 
        {
          istxtError = "txt_Modal_Confirm_New_Password";
          isError = "Pass";
        }

        if (isError !== "") 
        {
            if (isError === "Empty") 
            {
                setIsLoadProgress(false);
                Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);

            } 
            else if (isError === "Pass") 
            {
                setIsLoadProgress(false);
                Class_ETC_MsgErrorfocusByID(MsgDescription.ERR010, istxtError);
            } 
            
        } 
        else 
        {
            ChangePassword();
        }
        
    }

    function ChangePassword(){
        let token = localStorage.getItem("TStoken");
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("Content-Type", "application/json");
        var raw = ""
        raw = JSON.stringify({
            "staff_code": document.getElementById("lbl_Modal_Staff_code").innerHTML.trim(),
            "staff_password": document.getElementById("txt_Modal_New_Password").value.trim(),
            "old_password": ""
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
    
        fetch(configData.API_URL + "Staff_Changepass", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status_ID === 1) {

                document.getElementById("Model_ChangePassword_Close").click();
                setIsLoadProgress(false);
                Class_ETC_MsgSuccess(MsgDescription.CFM001, null);

            }
            else if (result.status_ID === 2) 
            {
                Class_ETC_SessionTimeOut();
            }
            else {
                
              setIsLoadProgress(false);
              Class_ETC_MsgError(result.status_Desc, null);
              
              
            }
          })
          .catch(error => {
            setIsLoadProgress(false);
            Class_ETC_MsgError(MsgDescription.ERR002, null);
           
          });
        
    }

    function onclick_ChangePassword_Header(){
        setIsLoadProgress(true);

        var istxtError = "";
        let isError = "";
        var txt_Modal_Old_Password_header = document.getElementById("txt_Modal_Old_Password_header").value.trim();
        var txt_Modal_New_Password_header = document.getElementById("txt_Modal_New_Password_header").value.trim();
        var txt_Modal_Confirm_New_Password_header = document.getElementById("txt_Modal_Confirm_New_Password_header").value.trim();

        if (txt_Modal_Old_Password_header === "") 
        {
            istxtError = "txt_Modal_Old_Password_header";
        } 
        else if (txt_Modal_New_Password_header === "") 
        {
            istxtError = "txt_Modal_New_Password_header";
        }
        else if (txt_Modal_Confirm_New_Password_header === "") 
        {
            istxtError = "txt_Modal_Confirm_New_Password_header";
        }
        if (istxtError !== "") 
        {
        isError = "Empty";
        }

        if (txt_Modal_New_Password_header !== txt_Modal_Confirm_New_Password_header) 
        {
          istxtError = "txt_Modal_Confirm_New_Password_header";
          isError = "Pass";
        }

        if (isError !== "") 
        {
            if (isError === "Empty") 
            {
                setIsLoadProgress(false);
                Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);

            } 
            else if (isError === "Pass") 
            {
                setIsLoadProgress(false);
                Class_ETC_MsgErrorfocusByID(MsgDescription.ERR010, istxtError);
            } 
            
        } 
        else 
        {
            ChangePassword_Header();
        }
        
    }

    function ChangePassword_Header(){
        let token = localStorage.getItem("TStoken");
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("Content-Type", "application/json");
        var raw = ""
        raw = JSON.stringify({
            "staff_code": "",
            "staff_password": document.getElementById("txt_Modal_New_Password_header").value.trim(),
            "old_password": document.getElementById("txt_Modal_Old_Password_header").value.trim(),
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
    
        fetch(configData.API_URL + "Staff_Changepass", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status_ID === 1) {

                document.getElementById("Model_ChangePassword_Close_header").click();
                setIsLoadProgress(false);
                Class_ETC_MsgSuccess(MsgDescription.CFM001, onclickLogout);

            }
            else if (result.status_ID === 2) 
            {
                Class_ETC_SessionTimeOut();
            }
            else {
                
              setIsLoadProgress(false);
              Class_ETC_MsgError(result.status_Desc, null);
              
              
            }
          })
          .catch(error => {
            setIsLoadProgress(false);
            Class_ETC_MsgError(MsgDescription.ERR002, null);
           
          });
        
    }

    function onclickLogout() {
        Class_ETC_Logout();
      }

 return (
    
    <>

    {isLoadProgress && (
            <div
            id="divLoadingProgress"
            name="divLoadingProgress"
            align="center"
            className="divWaiting"
            >
            <img alt="progress" src="../dist/img/loading.gif" />
            </div>
        )}

        {Act !== "header" &&
            <div className="modal fade" id="modal-change-pass">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header ">
                        <h4 className="modal-title"> <i className="nav-icon fa fa-key"></i>Change password</h4>
                        <button id="Model_ChangePassword_Close" type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="text-sm text-muted">Fullname(Eng) </div>
                                    <h6 id='lbl_Modal_Fullname'>{}</h6>

                                </div>                              
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="text-sm text-muted">Staff Code </div>
                                    <div className="input-group">
                                        <h5 id='lbl_Modal_Staff_code'>{}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="input-group">
                            <label className="text-sm">New Password <span className="text-danger">*</span> </label>
                            <div className="input-group">

                                <input
                                    type={newShow ? "text" : "password"}
                                    className="form-control"
                                    placeholder="New Password"
                                    id="txt_Modal_New_Password"
                                    />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-default"  onClick={toggleNewPassword}>
                                    <i id='i_Modal_New_Password' className={
                                            newShow
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                        }
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="text-sm">Confirm New Password <span className="text-danger">*</span> </label>
                            <div className="input-group">
                                <input
                                    type={confirmShow ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Confirm New Password"
                                    id="txt_Modal_Confirm_New_Password"
                                />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-default"  onClick={toggleChangeConfirmPassword}>
                                        <i id='i_Modal_Confirm_New_Password'
                                            className={
                                                confirmShow
                                                ? "fa fa-eye-slash"
                                                : "fa fa-eye"
                                            }
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-default" data-dismiss="modal">
                            <i className="fa  fa-times" /> Cancel
                        </button>                       
                        <button type="button" className="btn btn-primary" onClick={() => onclick_ChangePassword()}>
                            <i className="fa  fa-save"></i>  Save
                        </button>
                    </div>
                </div>
                {/* <!-- /.modal-content --> */}
            </div>
            {/* <!-- /.modal-dialog --> */}
            </div>  
        }

        {Act === "header" &&
            <div className="modal fade" id="modal-change-pass-header">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header ">
                        <h4 className="modal-title"> <i className="nav-icon fa fa-key"></i>Change password</h4>
                        <button id="Model_ChangePassword_Close_header" type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="text-sm text-muted">Fullname(Eng) </div>
                                    <h6 id='lbl_Modal_Fullname_header'>{}</h6>

                                </div>
                            </div>
                            <div className="col-md-6">
                                {/* <div className="form-group">
                                    <div className="text-sm text-muted">Fullname(Eng) </div>
                                    <h6 id='lbl_Modal_Fullname_header'>{}</h6>

                                </div> */}
                            </div>
                        </div>
                        <div className="input-group">
                            <label className="text-sm">Old Password <span className="text-danger">*</span> </label>
                            <div className="input-group">
                                <input
                                    type={passwordShow ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Password"
                                    id="txt_Modal_Old_Password_header"
                                />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-default"  onClick={togglePasswordShow}>
                                    <i
                                        id='i_Modal_Password'
                                        className={
                                            passwordShow
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                        }
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="input-group">
                            <label className="text-sm">New Password <span className="text-danger">*</span> </label>
                            <div className="input-group">

                                <input
                                    type={newShow ? "text" : "password"}
                                    className="form-control"
                                    placeholder="New Password"
                                    id="txt_Modal_New_Password_header"
                                    />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-default"  onClick={toggleNewPassword}>
                                    <i id='i_Modal_New_Password' className={
                                            newShow
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                        }
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="text-sm">Confirm New Password <span className="text-danger">*</span> </label>
                            <div className="input-group">
                                <input
                                    type={confirmShow ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Confirm New Password"
                                    id="txt_Modal_Confirm_New_Password_header"

                                />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-default"  onClick={toggleChangeConfirmPassword}>
                                    <i id='i_Modal_Confirm_New_Password'
                                        className={
                                            confirmShow
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                        }
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-default" data-dismiss="modal">
                            <i className="fa  fa-times" /> Cancel
                        </button>

                        <button type="button" className="btn btn-primary" onClick={() => onclick_ChangePassword_Header()}>
                            <i className="fa  fa-save"></i>  Save
                        </button>
                    </div>
                </div>
                {/* <!-- /.modal-content --> */}
            </div>
            {/* <!-- /.modal-dialog --> */}
            </div> 
        }

    </>     

 )};

export default ChangePasswordAction;

